import(/* webpackMode: "eager", webpackExports: ["DirectorySearchForm"] */ "/vercel/path0/app/Components/DirectorySearchForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoTooltip"] */ "/vercel/path0/app/Components/InfoTooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfessorPortrait"] */ "/vercel/path0/app/professors/ProfessorPortrait.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
